import {Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';

import {WebsiteService} from '../../shared/services/website.service';
import {Website} from '../../shared/models/website.model';
import {SettingService} from '../../shared/services/setting.service';
// import {TenantCssService} from '../../shared/services/tenant-css.service';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-server-select',
  templateUrl: './server-select.component.html',
  styleUrls: ['./server-select.component.css']
})
export class ServerSelectComponent implements OnInit, OnDestroy {
  serverSelectShown = false;
  fqdn: any;
  loadingFqdn = false;
  error: any;
  website: any;
  showLoader = false;
  queryParams = {};

  hostname: any;

  // currentApplicationVersion = environment.appVersion;

  constructor(private websiteService: WebsiteService,
              private renderer: Renderer2,
              // private tenantCss: TenantCssService,
              private config: SettingService,
              private route: ActivatedRoute,
              private router: Router,
  ) {

    this.queryParams = this.route.snapshot.queryParams;
  }

  ngOnInit() {
    this.fqdn = null;
    // this.tenantCss.removeStyle();

    // if (this.config.getClientHostname()) {
    //   this.router.navigate(['/login'], {relativeTo: this.route});
    // };

    // this.autoSelectTenant();

    this.hostnameLookup();

    this.renderer.addClass(document.body, 'single-page');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'single-page');
  }

  toggleShowServerSelect() {
    this.serverSelectShown = !this.serverSelectShown;
  }

  onSubmit() {
    this.error = null;

    if (this.fqdn == null || this.fqdn === '' || this.fqdn.length < 4) {
      this.error = 'required';
      return;
    }

    this.loadingFqdn = true;
    this.websiteService.lookup(this.fqdn)
      .subscribe(
        (response: any) => {
          this.website = null;
          if (response.status) {
            this.website = new Website().deserialize(response['result']['data']);
            console.log(response);
            this.websiteService.select(this.website, this.queryParams);
          } else if (response.status) {
            if (response['message'] === 'errInvalidHostname') {
              this.error = 'fqdnIsNotRegistered';
            }
          }

          if (this.website instanceof Website) {
            this.websiteService.select(this.website, this.queryParams);
          }

          this.loadingFqdn = false;
          this.router.navigate(['/login'], {relativeTo: this.route, queryParams: this.queryParams});
        },
        (error: any) => {
          this.loadingFqdn = false;
          if (error instanceof HttpErrorResponse && error.name === 'HttpErrorResponse') {
            this.error = 'HttpErrorResponse';
          }
        }
      );
  }

  autoSelectTenant() {
    this.showLoader = true;
    this.websiteService.lookupRegisteredDomain(null)
      .subscribe(
        (response: any) => {
          this.website = null;
          if (response.status) {
            this.website = new Website().deserialize(response['result']['data']);
            if (window.location.hostname !== 'localhost' && window.location.hostname !== 'sokrates.xyz') {
              this.checkTenantActive(+response['result']['data']['customer_id']);
            }

            // const admission = response['result']['data']['admission'];
            // localStorage.setItem('admission', JSON.stringify(admission));
            this.router.navigate(['/login'], {relativeTo: this.route, queryParams: this.queryParams});
          } else {
            this.showLoader = false;
          }
        },
        (error: any) => {
          this.showLoader = false;
        }
      );
  }

  checkTenantActive(customerId: number) {
    this.showLoader = true;
    this.websiteService.checkActiveTenant(customerId)
      .subscribe(
        (response: any) => {
          if (response.status) {
            if (!response['result']['data']['tenant-active']) {
              console.log('tenant inactive');
              // this.router.navigate(['../inactive-tenant']);
            }
          } else {
            this.showLoader = false;
          }
        },
        (error: any) => {
          this.showLoader = false;
        }
      );
  }

  hostnameLookup() {
    let origin = location.origin;
    console.log(origin)
    if ((origin.includes('localhost:4200') || origin === 'https://sokrates.xyz' )) {
      if (this.config.getClientHostname()) {
        let clientHostname = this.config.getClientHostname();
        origin = (clientHostname || '').replace("kalam-kudus.api.sokrates.xyz", "kalam-kudus.school-program.sokrates.xyz").replace(/^/, "https://");
      }
    }
    console.log(origin)
    this.websiteService.lookupHostname(origin).subscribe(
      (res) => {
        if (res.status) {
          this.hostname = res.data;
          if (this.hostname.is_deleted) {
            this.router.navigate(['/inactive-tenant'], { relativeTo: this.route });
          }
          this.websiteService.selectFromHostname(this.hostname, this.queryParams);
          // this.router.navigate(['/login'], { relativeTo: this.route });
        } else {
          console.log('customer not found');
        }
      },
      (err) => {
        console.log(err);
      },
    );
  }
}
